import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineMusicIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M21.65 2.24a1.0001 1.0001 0 0 0-.8-.23l-13 2A1 1 0 0 0 7 5v10.35A3.4497 3.4497 0 0 0 5.5 15 3.5 3.5 0 1 0 9 18.5v-7.64l11-1.69v4.18a3.4496 3.4496 0 0 0-1.5-.35 3.5 3.5 0 1 0 3.5 3.5V3a1.0005 1.0005 0 0 0-.35-.76ZM5.5 20a1.5002 1.5002 0 0 1-1.0607-2.5607A1.5 1.5 0 1 1 5.5 20Zm13-2a1.5003 1.5003 0 0 1-1.3858-.926A1.5 1.5 0 1 1 18.5 18ZM20 7.14 9 8.83v-3l11-1.66v2.97Z"/>
  </SvgIcon>
}

export default LineMusicIcon
